import { useCallback, useState } from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Row } from 'antd';
import { article_order_status } from 'constant/static';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useAfterCopyrightUnitGeneralControlMutation, useStartAfterCopyrightDecideProcessMutation } from 'services';
import { fetchError } from 'slices/commonSlice';
import { confirmGroupSiblingsConflict, openNotification } from 'utils';
import { useNavigate } from 'react-router-dom';

import { unitDecisions } from '../AfterCopyrightContentControl';

function ActionButtons({ showStartProcessButton, offerID, committee, offerStatus, handleCurrentIndex, currentIndex }) {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const [startAfterCopyrightDecideProcess] = useStartAfterCopyrightDecideProcessMutation();
  const [afterCopyrightRevert] = useAfterCopyrightUnitGeneralControlMutation();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  /**
   * telif sonrasi sureclerinde asamalardan sonra surecleri baslatmak icin kullanilir. TS - Madde Atama'da
   * grup kardeş uyarısı gelirse kullanıcı onaylarsa aynı gövde `force: true` ile yeniden gönderilir.
   */
  const handleStartProcess = async (body = { status: 2 }) => {
    const { error } = await startAfterCopyrightDecideProcess({ offerID: offerID, committee: committee, data: body });

    if (!body.force && confirmGroupSiblingsConflict(error, () => handleStartProcess({ ...body, force: true }))) return;

    if (error) {
      return dispatch(
        fetchError(
          formatMessage(
            {
              id: 'article.form.fetchError',
            },
            { error: error.status }
          )
        )
      );
    }
    openNotification({
      message: formatMessage({
        id: 'appModule.actionSuccessfully',
      }),
    });
  };

  /**
   * asamalar ilerlerken redaksiyon disinda madde atamaya bsip madde atamalari yapilabiliyor bu islemden sonra kalan surece donmek icin kullanilir
   */
  const handleReturnToCurrentStatus = useCallback(() => {
    handleCurrentIndex(currentIndex + 1);
    setTimeout(() => {
      const element = document.getElementById('routes-wrapper');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);
  }, [handleCurrentIndex, currentIndex]);

  /**
   * maddeyi siparis ve telif aşamasına geri gönderir
   */
  const revertToOrderAndCopyrightProcess = async () => {
    const data = {
      status: unitDecisions.revert,
    };
    const { error } = await afterCopyrightRevert({ offerID: offerID, committee: 'committee_control', data });
    if (error) {
      return dispatch(fetchError(error.message));
    }
    openNotification({
      message: formatMessage({ id: 'appModule.actionSuccessfully' }),
    });
    setOpen(false);
    navigate('/madde-teklifleri/tum-maddeler');
  };

  /**
   * telif sonrasi sureclerinde 2 ayri surec baslatiliyor bu kontrol hangi surec icin hangi text in gosterilmesi gerektiğini kontrol eder
   */
  const sendToRedactionText =
    offerStatus === article_order_status['Yayin Mudurlugu Madde Atama'] ? 'Yayın Müdürlüğü sürecini başlat' : 'Telif Sonrası Sürecini Başlat';
  if (showStartProcessButton) {
    return (
      <>
        <Row gutter={24}>
          {article_order_status['Yayin Mudurlugu Madde Atama'] !== offerStatus && (
            <Col span={12}>
              <Button
                onClick={() => setOpen(true)}
                block
              >
                Sipariş ve Telif Aşamasına Gönder
              </Button>
            </Col>
          )}
          <Col span={article_order_status['Yayin Mudurlugu Madde Atama'] !== offerStatus ? 12 : 24}>
            <Button
              type={article_order_status['Yayin Mudurlugu Madde Atama'] !== offerStatus ? 'primary' : 'default'}
              onClick={() => handleStartProcess()}
              block
            >
              {sendToRedactionText}
            </Button>
          </Col>
        </Row>
        <Modal
          title="Sipariş ve Telif Aşamasına Gönder"
          open={open}
          onCancel={() => setOpen(false)}
          okText="Evet"
          cancelText="Hayır"
          onOk={revertToOrderAndCopyrightProcess}
        >
          <p>Onayladığınızda madde sipariş ve telif aşamasına gönderilecektir.</p>
        </Modal>
      </>
    );
  }
  return (
    <Button
      block
      type="primary"
      onClick={handleReturnToCurrentStatus}
    >
      Mevcut Aşamaya Dön
      <ArrowRightOutlined />
    </Button>
  );
}
export default ActionButtons;
